import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AvpHeader from "../shared/header/AvpHeader";
import BreadCrumb from "../shared/header/BreadCrumb";
import AvpSaveFooter from "../shared/footer/AvpSaveFooter";
import {
  userIsLogged,
  getRoute,
  getUserAnag,
  apiGetAvpIstanzaById,
  apiGetAnaUtenteIndex,
  apiGetAvpTipoIstanze,
  apiPostAvpIstanza,
  apiGetAvpQRCodeAlign,
  apiGetAvpQRCodeStili,
  apiGetAvpQRCodePresets,
} from "../shared/manager/api_manager";
import { useEffectOnce } from "../shared/manager/use_effect_once";
import { getValueByQueryString } from "../shared/manager/util";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import { useLingueStore } from "../sistema/storeLingua";

export default function GestioneAvpIstanzeDetailScreen() {
  const navigate = useNavigate();

  const [alertSuccessOpen, setAlertSuccessOpen] = useState(false);
  const [alertErrorOpen, setAlertErrorOpen] = useState(false);

  const [currentAvpIstanza, setCurrenteAvpIstanza] = useState(null);
  const [currentAvp, setCurrentAvp] = useState(null);
  const [currentUtenti, setCurrentUtenti] = useState([]);
  const [currentTipiIstanze, setCurrentTipiIstanze] = useState([]);
  const [currentQRCodePresets, setCurrentQRCodePresets] = useState([]);
  const [currentQRCodeStili, setCurrentQRCodeStili] = useState([]);
  const [currentQRCodeAlign, setCurrentQRCodeAlign] = useState([]);

  //FORM
  const [formUtenteStatus, setFormUtenteStatus] = useState("");
  const [formTipoIstanzaStatus, setFormTipoIstanzaStatus] = useState("");
  const [formDurataSessioneStatus, setFormDurataSessioneStatus] = useState("");
  const formUtenteSelect = React.useRef();
  const formTipoIstanzaSelect = React.useRef();
  const formDurataSessioneInput = React.useRef();
  const formPinInput = React.useRef();
  const formQRCodeCheckbox = React.useRef();
  const formSfocaturaCheckbox = React.useRef();
  const { selectedLinguaTesto } = useLingueStore((state) => state);
  ;
  const breadCrumb = [
    {
      title: selectedLinguaTesto?.GestioneAvpIstanzeDetailBreadcrumb1,
      link: "/avp",
    },
    {
      title:
        selectedLinguaTesto?.GestioneAvpIstanzeDetailBreadcrumb2 +
        (currentAvp != null ? currentAvp : ""),
      link: null,
    },
    {
      title: selectedLinguaTesto?.GestioneAvpIstanzeDetailBreadcrumb3,
      link: "/avp/istanze?idavp=" + (currentAvp != null ? currentAvp : ""),
    },
    {
      title: selectedLinguaTesto?.GestioneAvpIstanzeDetailBreadcrumb4,
      link: null,
    },
  ];

  useEffectOnce(() => {
    startPage();

    return () => stopPage();
  });

  function startPage() {
    console.log("startPage");

    if (userIsLogged() == false) {
      navigate("/login");
    } else {
      var route = getRoute();
      if (!route.funzioni.some((g) => g.idFunzione === 20)) {
        navigate("/");
      }
      initPage();
    }
  }

  function stopPage() {
    console.log("stopPage");
  }

  function initPage() {
    console.log("initPage");

    loadAvpIstanza();
  }

  function loadAvpIstanza() {
    const url = window.location.pathname;
    const idAvp = parseInt(getValueByQueryString("idavp"));
    setCurrentAvp(idAvp);
    const idAvpIstanza = url.substring(url.lastIndexOf("/") + 1);

    if (idAvpIstanza != null && idAvpIstanza != "" && idAvpIstanza !== "0") {
      apiGetAvpIstanzaById(idAvpIstanza, avpIstanzaCallback);
    } else {
      let idUtente = 0;
      let userAnag = getUserAnag();
      if (userAnag != null) {
        idUtente = userAnag.idutente;
      }
      let istanza = {
        idUtenteAvp: 0,
        //idUtente: idUtente,
        idAvp: idAvp,
        idTipoIstanza: 1,
        durataSessione: 0,
        qrCode: false,
        pin: "",
        sysUser: "",
        sysDate: new Date().toISOString(),
        sysAttivo: true,
      };
      setCurrenteAvpIstanza(istanza);
      apiGetAnaUtenteIndex("0", utentiCallback);
    }
  }

  function avpIstanzaCallback(response) {
    console.log(response);
    if (response != null && response.status >= 200 && response.status < 400) {
      console.log(response.data);
      setCurrenteAvpIstanza(response.data);
      apiGetAnaUtenteIndex("0", utentiCallback);
    }
  }

  function utentiCallback(response) {
    console.log(response);
    if (response != null && response.status >= 200 && response.status < 400) {
      console.log(response.data);
      setCurrentUtenti(response.data);
      apiGetAvpTipoIstanze(tipiIstanzeCallback);
    }
  }

  function tipiIstanzeCallback(response) {
    console.log(response);
    if (response != null && response.status >= 200 && response.status < 400) {
      console.log(response.data);
      setCurrentTipiIstanze(response.data);
      loadQRCodePresets(function () {
        loadQRCodeStili(function () {
          loadQRCodeAlign(function () {});
        });
      });
    }
  }

  function loadQRCodePresets(callback) {
    apiGetAvpQRCodePresets(function (response) {
      if (response != null && response.status >= 200 && response.status < 400) {
        setCurrentQRCodePresets(response.data);
      }
      callback();
    });
  }

  function loadQRCodeStili(callback) {
    apiGetAvpQRCodeStili(function (response) {
      if (response != null && response.status >= 200 && response.status < 400) {
        setCurrentQRCodeStili(response.data);
      }
      callback();
    });
  }

  function loadQRCodeAlign(callback) {
    apiGetAvpQRCodeAlign(function (response) {
      if (response != null && response.status >= 200 && response.status < 400) {
        setCurrentQRCodeAlign(response.data);
      }
      callback();
    });
  }

  function onUtenteChange(event) {
    let value = event.target.value;
    currentAvpIstanza.idUtente = value;
    let newObj = Object.assign({}, currentAvpIstanza);
    setCurrenteAvpIstanza(newObj);
  }

  function onTipoIstanzaChange(event) {
    let value = event.target.value;
    currentAvpIstanza.idTipoIstanza = parseInt(value);
    let newObj = Object.assign({}, currentAvpIstanza);
    setCurrenteAvpIstanza(newObj);
  }
  function onOrientamentoIstanzaChange(event) {
    let value = event.target.value;
    currentAvpIstanza.tipoLayout = parseInt(value);
    let newObj = Object.assign({}, currentAvpIstanza);
    setCurrenteAvpIstanza(newObj);
  }

  function onDurataSessioneChange(event) {
    let value = event.target.value;
    currentAvpIstanza.durataSessione = value;
    let newObj = Object.assign({}, currentAvpIstanza);
    setCurrenteAvpIstanza(newObj);
  }

  function onPinChange(event) {
    let value = event.target.value;
    currentAvpIstanza.pin = value;
    let newObj = Object.assign({}, currentAvpIstanza);
    setCurrenteAvpIstanza(newObj);
  }

  function onSfocaturaChange(event) {
    let value = event.target.checked;
    currentAvpIstanza.sfocatura = value;
    let newObj = Object.assign({}, currentAvpIstanza);
    setCurrenteAvpIstanza(newObj);
  }

  function onQRCodeChange(event) {
    let value = event.target.checked;
    currentAvpIstanza.qrCode = value;
    let newObj = Object.assign({}, currentAvpIstanza);
    setCurrenteAvpIstanza(newObj);
  }

  function onQRCodeTextChange(event) {
    let value = event.target.value;
    currentAvpIstanza.qrCodeText = value;
    let newObj = Object.assign({}, currentAvpIstanza);
    setCurrenteAvpIstanza(newObj);
  }

  function onQRCodePresetChange(event) {
    let value = event.target.value;
    currentAvpIstanza.qrCodePreset = eval(value);
    let newObj = Object.assign({}, currentAvpIstanza);
    setCurrenteAvpIstanza(newObj);
  }

  function onQRCodeStileChange(event) {
    let value = event.target.value;
    currentAvpIstanza.qrCodeStyleClass = eval(value);
    let newObj = Object.assign({}, currentAvpIstanza);
    setCurrenteAvpIstanza(newObj);
  }

  function onQRCodeAlignChange(event) {
    let value = event.target.value;
    currentAvpIstanza.qrCodeAllineamento = eval(value);
    let newObj = Object.assign({}, currentAvpIstanza);
    setCurrenteAvpIstanza(newObj);
  }

  function onQRCodeSizeChange(event) {
    let value = event.target.value;
    currentAvpIstanza.qrCodeDimensioniQR = eval(value);
    let newObj = Object.assign({}, currentAvpIstanza);
    setCurrenteAvpIstanza(newObj);
  }

  function validateForm() {
    console.log("validateForm");
    let valid = true;

    return valid;
  }

  function saveIstanza() {
    if (currentAvpIstanza != null) {
      if (
        currentAvpIstanza.qrCodeStyleClass == null &&
        currentQRCodeStili != null &&
        currentQRCodeStili.length > 0
      ) {
        currentAvpIstanza.qrCodeStyleClass =
          currentQRCodeStili[0].idQRCodeStile;
      }
      if (currentAvpIstanza.qrCodeDimensioniQR == null) {
        currentAvpIstanza.qrCodeDimensioniQR = 400;
      }
      let newObj = Object.assign({}, currentAvpIstanza);
      setCurrenteAvpIstanza(newObj);
    }

    apiPostAvpIstanza(currentAvpIstanza, function (response) {
      if (response != null && response.status >= 200 && response.status < 400) {
        setAlertSuccessOpen(true);
        setAlertErrorOpen(false);
        navigate("/avp/istanze?idavp=" + currentAvp);
      } else {
        setAlertSuccessOpen(false);
        setAlertErrorOpen(true);
      }
    });
  }

  function footerCancelCallback() {
    console.log("cancel");

    navigate("/avp/istanze?idavp=" + currentAvp);
  }

  function footerSaveCallback() {
    console.log("save");

    if (validateForm()) {
      saveIstanza();
    }
  }

  return (
    <div id="avp-gestioneavp-screen">
      <AvpHeader selectedMenuId={"avp"} />
      <BreadCrumb
        items={breadCrumb}
        helpLink={"help.html#modificaavpistanza"}
      />
      <div id="avp-cms-screen-container">
        <Collapse in={alertSuccessOpen}>
          <Alert
            variant="filled"
            severity="success"
            onClose={() => {
              setAlertSuccessOpen(false);
            }}
          >
            {selectedLinguaTesto?.GestioneAvpIstanzeDetailAlertSuccess}
          </Alert>
        </Collapse>
        <Collapse in={alertErrorOpen}>
          <Alert
            variant="filled"
            severity="error"
            onClose={() => {
              setAlertErrorOpen(false);
            }}
          >
            {selectedLinguaTesto?.GestioneAvpIstanzeDetailAlertError}
          </Alert>
        </Collapse>
        <div className="avp-cms-screen-title">
          {selectedLinguaTesto?.GestioneAvpIstanzeDetailTitle}
        </div>
        <div className="avp-cms-screen-content">
          <div
            className="avp-cms-screen-content-row clearfix"
            style={{ display: "none" }}
          >
            <div className="avp-cms-screen-content-column">
              <label htmlFor="avp-form-utente" className="required">
                {selectedLinguaTesto?.GestioneAvpIstanzeDetailUser}
              </label>
              <br />
              <select
                ref={formUtenteSelect}
                id="avp-form-utente"
                value={
                  currentAvpIstanza != null ? currentAvpIstanza.idUtente : ""
                }
                onChange={onUtenteChange}
              >
                {currentUtenti != null && currentUtenti.length > 0 ? (
                  currentUtenti.map((item, i) => {
                    if (currentAvpIstanza != null) {
                      return (
                        <option key={item.idutente} value={item.idutente}>
                          {item.userName}
                        </option>
                      );
                    } else {
                      return "";
                    }
                  })
                ) : (
                  <option></option>
                )}
              </select>
            </div>
          </div>

          <div className="avp-cms-screen-content-row clearfix">
            <div className="avp-cms-screen-content-column">
              <label htmlFor="avp-form-tipoistanza" className="required">
                {selectedLinguaTesto?.GestioneAvpIstanzeDetailIstanceType}
              </label>
              <br />
              <select
                ref={formTipoIstanzaSelect}
                id="avp-form-tipoistanza"
                value={
                  currentAvpIstanza != null
                    ? currentAvpIstanza.idTipoIstanza
                    : ""
                }
                onChange={onTipoIstanzaChange}
              >
                {currentTipiIstanze != null && currentTipiIstanze.length > 0 ? (
                  currentTipiIstanze.map((item, i) => {
                    if (currentAvpIstanza != null) {
                      return (
                        <option
                          key={item.idTipoIstanza}
                          value={item.idTipoIstanza}
                        >
                          {item.descTipoIstanza}
                        </option>
                      );
                    } else {
                      return "";
                    }
                  })
                ) : (
                  <option></option>
                )}
              </select>
            </div>
          </div>
          <div className="avp-cms-screen-content-row clearfix">
            <div className="avp-cms-screen-content-column">
              <label htmlFor="avp-form-tipoistanza" className="required">
                {
                  selectedLinguaTesto?.GestioneAvpIstanzeDetailIstanceOrientation
                }
              </label>
              <br />
              <select
                ref={formTipoIstanzaSelect}
                id="avp-form-tipoistanza"
                value={
                  currentAvpIstanza != null ? currentAvpIstanza.tipoLayout : "0"
                }
                onChange={onOrientamentoIstanzaChange}
              >
                <option value="0">
                  {
                    selectedLinguaTesto?.GestioneAvpIstanzeDetailOptionOrizzontal
                  }
                </option>
                <option value="1">
                  {selectedLinguaTesto?.GestioneAvpIstanzeDetailOptionVeritcal}
                </option>
                {/* { 
                  currentTipiIstanze!=null && currentTipiIstanze.length>0 ?
                  currentTipiIstanze.map((item, i) => { 
                      if (currentAvpIstanza!=null ) {
                        return (<option key={item.idTipoIstanza} value={item.idTipoIstanza}  >{item.descTipoIstanza}</option>) 
                      }
                      else {
                        return "";
                      }
                      
                    })
                  : (<option></option>)
                    
                  
                }   */}
              </select>
            </div>
          </div>

          <div className="avp-cms-screen-content-row clearfix">
            <div className="avp-cms-screen-content-column">
              <label for="avp-form-duratasessione" className="required">
                {selectedLinguaTesto?.GestioneAvpIstanzeDetailDurationSession}
              </label>
              <br />
              <input
                id="avp-form-duratasessione"
                ref={formDurataSessioneInput}
                className={formDurataSessioneStatus}
                value={
                  currentAvpIstanza != null
                    ? currentAvpIstanza.durataSessione
                    : 0
                }
                defaultValue="0"
                type="number"
                min="0"
                onChange={onDurataSessioneChange}
              />
            </div>
          </div>

          <div className="avp-cms-screen-content-row clearfix">
            <div className="avp-cms-screen-content-column">
              <label for="avp-form-pin">
                {selectedLinguaTesto?.GestioneAvpIstanzeDetailPIN}
              </label>
              <br />
              <input
                id="avp-form-pin"
                ref={formPinInput}
                type="text"
                value={currentAvpIstanza != null ? currentAvpIstanza.pin : ""}
                defaultValue=""
                onChange={onPinChange}
                maxLength={5}
              />
            </div>
          </div>

          <div className="avp-cms-screen-content-row clearfix">
            <input
              id="avp-form-sfocatura"
              ref={formSfocaturaCheckbox}
              type="checkbox"
              onChange={onSfocaturaChange}
              checked={
                currentAvpIstanza != null && currentAvpIstanza.sfocatura
                  ? "checked"
                  : ""
              }
            />
            <label for="avp-form-sfocatura">
              {selectedLinguaTesto?.GestioneAvpIstanzeDetailBlur}
            </label>
          </div>

          <div className="avp-cms-screen-content-row clearfix">
            <input
              id="avp-form-qrcode"
              ref={formQRCodeCheckbox}
              type="checkbox"
              onChange={onQRCodeChange}
              checked={
                currentAvpIstanza != null && currentAvpIstanza.qrCode
                  ? "checked"
                  : ""
              }
            />
            <label for="avp-form-qrcode">
              {selectedLinguaTesto?.GestioneAvpIstanzeDetailQRcode}
            </label>
          </div>

          <div
            id="avp-form-qrcode-settings"
            style={{
              display:
                currentAvpIstanza != null && currentAvpIstanza.qrCode
                  ? "block"
                  : "none",
            }}
          >
            <div className="avp-cms-screen-content-row clearfix">
              <div
                className="avp-cms-screen-content-column"
                style={{ width: "50%" }}
              >
                <label for="avp-form-qrcode-text">
                  {selectedLinguaTesto?.GestioneAvpIstanzeDetailText}
                </label>
                <br />
                <input
                  id="avp-form-qrcode-text"
                  type="text"
                  value={
                    currentAvpIstanza != null
                      ? currentAvpIstanza.qrCodeText
                      : ""
                  }
                  style={{ "max-width": "none" }}
                  defaultValue=""
                  onChange={onQRCodeTextChange}
                />
              </div>
            </div>

            <div className="avp-cms-screen-content-row clearfix">
              <div className="avp-cms-screen-content-column">
                <label htmlFor="avp-form-qrcode-preset">
                  {selectedLinguaTesto?.GestioneAvpIstanzeDetailPreset}
                </label>
                <br />
                <select
                  id="avp-form-qrcode-preset"
                  value={
                    currentAvpIstanza != null
                      ? currentAvpIstanza.qrCodePreset
                      : ""
                  }
                  onChange={onQRCodePresetChange}
                >
                  {currentQRCodePresets != null &&
                  currentQRCodePresets.length > 0 ? (
                    currentQRCodePresets.map((item, i) => {
                      if (currentAvpIstanza != null) {
                        return (
                          <option
                            key={item.idQRCodePreset}
                            value={item.idQRCodePreset}
                          >
                            {item.descQRCodePreset}
                          </option>
                        );
                      } else {
                        return "";
                      }
                    })
                  ) : (
                    <option></option>
                  )}
                </select>
              </div>

              <div className="avp-cms-screen-content-column">
                <label htmlFor="avp-form-qrcode-stile">
                  {selectedLinguaTesto?.GestioneAvpIstanzeDetailStyles}
                </label>
                <br />
                <select
                  id="avp-form-qrcode-stile"
                  value={
                    currentAvpIstanza != null
                      ? currentAvpIstanza.qrCodeStyleClass
                      : ""
                  }
                  onChange={onQRCodeStileChange}
                >
                  {currentQRCodeStili != null &&
                  currentQRCodeStili.length > 0 ? (
                    currentQRCodeStili.map((item, i) => {
                      if (currentAvpIstanza != null) {
                        return (
                          <option
                            key={item.idQRCodeStile}
                            value={item.idQRCodeStile}
                          >
                            {item.nomeStile}
                          </option>
                        );
                      } else {
                        return "";
                      }
                    })
                  ) : (
                    <option></option>
                  )}
                </select>
              </div>

              <div className="avp-cms-screen-content-column">
                <label htmlFor="avp-form-qrcode-align">
                  {selectedLinguaTesto?.GestioneAvpIstanzeDetailAlign}
                </label>
                <br />
                <select
                  id="avp-form-qrcode-align"
                  value={
                    currentAvpIstanza != null
                      ? currentAvpIstanza.qrCodeAllineamento
                      : ""
                  }
                  onChange={onQRCodeAlignChange}
                >
                  {currentQRCodeAlign != null &&
                  currentQRCodeAlign.length > 0 ? (
                    currentQRCodeAlign.map((item, i) => {
                      if (currentAvpIstanza != null) {
                        return (
                          <option
                            key={item.idQRCodeAlign}
                            value={item.idQRCodeAlign}
                          >
                            {item.descQRCodeAlign}
                          </option>
                        );
                      } else {
                        return "";
                      }
                    })
                  ) : (
                    <option></option>
                  )}
                </select>
              </div>

              <div className="avp-cms-screen-content-column">
                <label for="avp-form-qrcode-size">
                  {selectedLinguaTesto?.GestioneAvpIstanzeDetailDimension}
                </label>
                <br />
                <input
                  id="avp-form-qrcode-size"
                  type="number"
                  value={
                    currentAvpIstanza != null
                      ? currentAvpIstanza.qrCodeDimensioniQR
                      : "400"
                  }
                  style={{ "max-width": "none" }}
                  defaultValue="400"
                  onChange={onQRCodeSizeChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <AvpSaveFooter
        saveCallback={footerSaveCallback}
        cancelCallback={footerCancelCallback}
      />
    </div>
  );
}
